// frontend/src/components/PageLoading.jsx
// SignalIQ Intelligence route/module loading state — theme-aware and reusable.

import React from "react";

export default function PageLoading({
  label = "Preparing SignalIQ Intelligence…",
  sublabel = "Loading the selected module.",
  overlay = false,
  compact = false,
}) {
  return (
    <div
      className={[
        "siq-page-loading",
        overlay ? "siq-page-loading--overlay" : "",
        compact ? "siq-page-loading--compact" : "",
      ]
        .filter(Boolean)
        .join(" ")}
      role="status"
      aria-live="polite"
      aria-busy="true"
    >
      <div className="siq-page-loading__card">
        <div className="siq-page-loading__spinner" aria-hidden="true" />

        <div className="siq-page-loading__content">
          <div className="siq-page-loading__title">{label}</div>

          {sublabel ? (
            <div className="siq-page-loading__message">{sublabel}</div>
          ) : null}

          <div className="siq-page-loading__bar" aria-hidden="true">
            <span />
          </div>
        </div>
      </div>
    </div>
  );
}